import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "row gap-08" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row" }

import SharedService from "@/services/SharedService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esDataCard',
  props: {
    title: {},
    icon: {},
    folderIcon: {},
    compact: { type: Boolean },
    backgroundClass: {},
    txtClass: { default: '' },
    usePadS: { type: Boolean, default: true },
    iconPositionRight: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const getClass = () => {
  const compactClass = props.compact ? ' compact' : '';
  const padSClass = props.usePadS ? ' pad-s' : '';

  return 'es-data-card ' +  props.backgroundClass + compactClass + padSClass;
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(getClass())
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.icon && _ctx.folderIcon && !_ctx.iconPositionRight)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(SharedService).getIcon(_ctx.icon, false, _ctx.folderIcon),
            class: "square-14 icon-hover",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('icon-click')), ["stop"]))
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode(_component_text_item, {
        txt: _ctx.title,
        class: _normalizeClass([_ctx.txtClass, "w-full"])
      }, null, 8, ["txt", "class"]),
      (_ctx.icon && _ctx.folderIcon && _ctx.iconPositionRight)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _unref(SharedService).getIcon(_ctx.icon, false, _ctx.folderIcon),
            class: "square-14 icon-hover",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('icon-click')), ["stop"]))
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})